export const cmvReportV2 = {
	label: "CMV",
	description:
		"COGS (Cost of Goods Sold) is a financial indicator that represents direct costs.",
	states: {
		empty: {
			title: "No CMV data found",
			description: "There is no CMV information for the selected period.",
		},
		error: {
			title: "Unable to load CMV",
			description:
				"An error occurred while loading the CMV report. Please try again shortly.",
		},
	},
	kpis: {
		itemsSold: "Items sold",
		grossRevenue: "Gross revenue",
		totalCost: "Total cost",
		marginCmv: "CMV margin",
		cmvPercent: "CMV percentage",
	},
	header: {
		periodPlaceholder: "Select period",
		export: "Export Excel",
		type: {
			all: "All products",
			fromPlace: "Place products",
			fromVendor: "Vendor products",
		},
	},
	filters: {
		searchPlaceholder: "Search by product or SKU",
		categoriesPlaceholder: "All categories",
		viewBy: {
			byCategory: "View by categories",
			byProduct: "View by products",
		},
	},
	chart: {
		title: "Revenue vs CMV by category",
		legend: {
			revenue: "Revenue",
			cmv: "CMV",
		},
		tooltip: {
			revenue: "Revenue",
			cmv: "CMV",
		},
		empty: {
			title: "No chart data",
			description: "No categories with sales for the selected period and filters.",
		},
	},
	table: {
		columns: {
			category: "CATEGORY",
			soldQty: "SOLD QTY",
			grossRevenue: "GROSS REVENUE",
			totalCost: "TOTAL COST",
			costPercent: "COST PERCENTAGE",
			cmv: "COGS",
			margin: "MARGIN",
			product: "Product",
			sku: "SKU",
			productSoldQty: "Sold qty",
			losses: "Losses",
			unitValue: "Unit value",
			unitCost: "Unit cost",
			productTotalValue: "Total value",
			productTotalCost: "Total cost",
			productMargin: "Margin",
			productCmv: "COGS",
		},
		empty: {
			title: "No products found",
			description: "There are no products for the selected filters.",
		},
	},
	zeroedCost: {
		card: {
			label: "Products with zeroed cost",
			alert: {
				title: "Improve your CMV",
				description: "Adjust the product costs.",
				cta: "Adjust products",
			},
			success: {
				title: "CMV without inconsistencies",
				description: "All products have updated costs",
			},
		},
		drawer: {
			title: "Products with zeroed cost",
			back: "Back",
			cancel: "Cancel",
			submit: "Update products",
			success: "Costs updated successfully",
			loading: "Loading products...",
			choice: {
				title: "How do you want to update the zeroed products' costs?",
				manual: {
					title: "Manually",
					description:
						"View all zeroed products and update the costs without leaving the dashboard.",
				},
				xlsx: {
					title: "In bulk via Excel spreadsheet",
					description:
						"We provide a spreadsheet with all zeroed products; fill in the costs and upload it here.",
				},
			},
			manual: {
				subtitle: "Update zeroed costs manually",
				empty: "No products with zeroed cost.",
				error: "Could not load the products.",
				columns: {
					product: "Product",
					sku: "SKU",
					storage: "Storage",
					lastCost: "Last cost",
					unitCost: "Unit cost",
				},
			},
			xlsx: {
				subtitle: "Update zeroed costs in bulk",
				downloadSheet: "Download spreadsheet with zeroed-cost products",
				dropzone: {
					title: "Drag and drop the XLSX to edit in bulk",
					action: "or select the files",
					helper:
						"Download the template spreadsheet, update the costs of the zeroed products and upload the file here to update in bulk.",
				},
				filesLabel: "1 of 1 files",
				file: {
					loadError: "Failed to load the file. Try again.",
					rowsError: "The spreadsheet has products with issues.",
					downloadErrors: "Download spreadsheet with errors",
					remove: "Remove file",
				},
				sheet: {
					fileName: "Products with zeroed costs",
					invalidFileName: "Products with zeroed costs - errors",
					columns: {
						name: "Product",
						sku: "SKU",
						storage: "Storage",
						productId: "Product ID",
						storageId: "Storage ID",
						lastCost: "Last cost",
						unitCost: "Unit cost",
					},
				},
			},
		},
		successDialog: {
			windowTitle: "Zeroed-cost products updated",
			title: "Products updated successfully!",
			description: "Your CMV report is up to date.",
			remaining: "But there are new products with zeroed costs.",
			confirm: "Got it",
		},
	},
};
